// Text only. For addresses use `addressesEqual`, which also folds zero-padding.
export const areStringsEqual = (a: string | undefined, b: string | undefined) => {
  if (!a || !b) return false;
  return a.toLowerCase() === b.toLowerCase();
};

export function ellipseMiddle(
  str: string | undefined,
  { prefix, suffix, ellipsis = "..." }: { prefix: number; suffix: number; ellipsis?: string },
): string {
  if (!str) return "";
  if (str.length <= prefix + suffix) return str;
  return `${str.slice(0, prefix)}${ellipsis}${str.slice(-suffix)}`;
}

export function ellipseString(str: string | undefined, maxLength: number) {
  if (!str) return "";
  if (str.length <= maxLength) return str;
  const half = Math.max(1, Math.floor(maxLength / 2 - 1));
  return ellipseMiddle(str, { prefix: half, suffix: half });
}

export function shortHash(hash: string, prefix = 6, suffix = 4): string {
  return ellipseMiddle(hash, { prefix, suffix, ellipsis: "…" });
}

export function asString(value: unknown, fallback: string): string {
  return typeof value === "string" ? value : fallback;
}
